/**
 * Landing 도메인 Query Hook Wrapper
 *
 * Factory 기반 구현으로 Landing 관련 데이터를 조회합니다.
 * 모든 쿼리는 InfiniteQuery 패턴을 사용합니다.
 */

import {useInfiniteQuery} from '@tanstack/react-query';
import {LANDING_QUERY_KEY_MAP} from '../api/landing/constant';
import {landingFactory} from '../factory/landingFactory';

// ============================================
// useInfiniteSeriesCardViewLandingListQuery
// ============================================

export function useInfiniteSeriesCardViewLandingListQuery(
  ...args: Parameters<typeof landingFactory.infiniteSeriesCardViewLandingList>
) {
  return useInfiniteQuery(
    landingFactory.infiniteSeriesCardViewLandingList(...args)
  );
}

useInfiniteSeriesCardViewLandingListQuery.getKey = (
  ...args: Parameters<typeof LANDING_QUERY_KEY_MAP.seriesCardViewLandingList>
) => [...LANDING_QUERY_KEY_MAP.seriesCardViewLandingList(...args)];

// ============================================
// useInfiniteSeriesListViewLandingListQuery
// ============================================

export function useInfiniteSeriesListViewLandingListQuery(
  ...args: Parameters<typeof landingFactory.infiniteSeriesListViewLandingList>
) {
  return useInfiniteQuery(
    landingFactory.infiniteSeriesListViewLandingList(...args)
  );
}

useInfiniteSeriesListViewLandingListQuery.getKey = (
  ...args: Parameters<typeof LANDING_QUERY_KEY_MAP.seriesListViewLandingList>
) => [...LANDING_QUERY_KEY_MAP.seriesListViewLandingList(...args)];

// ============================================
// useInfiniteSeriesPosterViewLandingListQuery
// ============================================

export function useInfiniteSeriesPosterViewLandingListQuery(
  ...args: Parameters<typeof landingFactory.infiniteSeriesPosterViewLandingList>
) {
  return useInfiniteQuery(
    landingFactory.infiniteSeriesPosterViewLandingList(...args)
  );
}

useInfiniteSeriesPosterViewLandingListQuery.getKey = (
  ...args: Parameters<typeof LANDING_QUERY_KEY_MAP.seriesPosterViewLandingList>
) => [...LANDING_QUERY_KEY_MAP.seriesPosterViewLandingList(...args)];

// ============================================
// useInfiniteSetListViewLandingListQuery
// ============================================

export function useInfiniteSetListViewLandingListQuery(
  ...args: Parameters<typeof landingFactory.infiniteSetListViewLandingList>
) {
  return useInfiniteQuery(
    landingFactory.infiniteSetListViewLandingList(...args)
  );
}

useInfiniteSetListViewLandingListQuery.getKey = (
  ...args: Parameters<typeof LANDING_QUERY_KEY_MAP.setListViewLandingList>
) => [...LANDING_QUERY_KEY_MAP.setListViewLandingList(...args)];

// ============================================
// useInfiniteSetPosterViewLandingListQuery
// ============================================

export function useInfiniteSetPosterViewLandingListQuery(
  ...args: Parameters<typeof landingFactory.infiniteSetPosterViewLandingList>
) {
  return useInfiniteQuery(
    landingFactory.infiniteSetPosterViewLandingList(...args)
  );
}

useInfiniteSetPosterViewLandingListQuery.getKey = (
  ...args: Parameters<typeof LANDING_QUERY_KEY_MAP.setPosterViewLandingList>
) => [...LANDING_QUERY_KEY_MAP.setPosterViewLandingList(...args)];

// ============================================
// useInfiniteSingleListViewLandingListQuery
// ============================================

export function useInfiniteSingleListViewLandingListQuery(
  ...args: Parameters<typeof landingFactory.infiniteSingleListViewLandingList>
) {
  return useInfiniteQuery(
    landingFactory.infiniteSingleListViewLandingList(...args)
  );
}

useInfiniteSingleListViewLandingListQuery.getKey = (
  ...args: Parameters<typeof LANDING_QUERY_KEY_MAP.singleListViewLandingList>
) => [...LANDING_QUERY_KEY_MAP.singleListViewLandingList(...args)];

// ============================================
// useInfiniteStaticLandingDayOfWeekSectionQuery
// ============================================

export function useInfiniteStaticLandingDayOfWeekSectionQuery(
  ...args: Parameters<
    typeof landingFactory.infiniteStaticLandingDayOfWeekSection
  >
) {
  return useInfiniteQuery(
    landingFactory.infiniteStaticLandingDayOfWeekSection(...args)
  );
}

useInfiniteStaticLandingDayOfWeekSectionQuery.getKey = (
  ...args: Parameters<
    typeof LANDING_QUERY_KEY_MAP.staticLandingDayOfWeekSection
  >
) => [...LANDING_QUERY_KEY_MAP.staticLandingDayOfWeekSection(...args)];

// ============================================
// useInfiniteStaticLandingEventSectionQuery
// ============================================

export function useInfiniteStaticLandingEventSectionQuery(
  ...args: Parameters<typeof landingFactory.infiniteStaticLandingEventSection>
) {
  return useInfiniteQuery(
    landingFactory.infiniteStaticLandingEventSection(...args)
  );
}

useInfiniteStaticLandingEventSectionQuery.getKey = (
  ...args: Parameters<typeof LANDING_QUERY_KEY_MAP.staticLandingEventSection>
) => [...LANDING_QUERY_KEY_MAP.staticLandingEventSection(...args)];

// ============================================
// useInfiniteStaticLandingFreeSeriesSectionQuery
// ============================================

export function useInfiniteStaticLandingFreeSeriesSectionQuery(
  ...args: Parameters<
    typeof landingFactory.infiniteStaticLandingFreeSeriesSection
  >
) {
  return useInfiniteQuery(
    landingFactory.infiniteStaticLandingFreeSeriesSection(...args)
  );
}

useInfiniteStaticLandingFreeSeriesSectionQuery.getKey = (
  ...args: Parameters<
    typeof LANDING_QUERY_KEY_MAP.infiniteStaticLandingFreeSeriesSection
  >
) => [...LANDING_QUERY_KEY_MAP.infiniteStaticLandingFreeSeriesSection(...args)];

// ============================================
// useInfiniteStaticLandingGenreSectionQuery
// ============================================

export function useInfiniteStaticLandingGenreSectionQuery(
  ...args: Parameters<typeof landingFactory.infiniteStaticLandingGenreSection>
) {
  return useInfiniteQuery(
    landingFactory.infiniteStaticLandingGenreSection(...args)
  );
}

useInfiniteStaticLandingGenreSectionQuery.getKey = (
  ...args: Parameters<
    typeof LANDING_QUERY_KEY_MAP.infiniteStaticLandingGenreSection
  >
) => [...LANDING_QUERY_KEY_MAP.infiniteStaticLandingGenreSection(...args)];

// ============================================
// useInfiniteStaticLandingOriginalSectionQuery
// ============================================

export function useInfiniteStaticLandingOriginalSectionQuery(
  ...args: Parameters<
    typeof landingFactory.infiniteStaticLandingOriginalSection
  >
) {
  return useInfiniteQuery(
    landingFactory.infiniteStaticLandingOriginalSection(...args)
  );
}

useInfiniteStaticLandingOriginalSectionQuery.getKey = (
  ...args: Parameters<
    typeof LANDING_QUERY_KEY_MAP.infiniteStaticLandingOriginalSection
  >
) => [...LANDING_QUERY_KEY_MAP.infiniteStaticLandingOriginalSection(...args)];

// ============================================
// useInfiniteStaticLandingRankingSectionQuery
// ============================================

export function useInfiniteStaticLandingRankingSectionQuery(
  ...args: Parameters<typeof landingFactory.infiniteStaticLandingRankingSection>
) {
  return useInfiniteQuery(
    landingFactory.infiniteStaticLandingRankingSection(...args)
  );
}

useInfiniteStaticLandingRankingSectionQuery.getKey = (
  ...args: Parameters<
    typeof LANDING_QUERY_KEY_MAP.infiniteStaticLandingRankingSection
  >
) => [...LANDING_QUERY_KEY_MAP.infiniteStaticLandingRankingSection(...args)];

// ============================================
// useInfiniteStaticLandingTodayUpSectionQuery
// ============================================

export function useInfiniteStaticLandingTodayUpSectionQuery(
  ...args: Parameters<typeof landingFactory.infiniteStaticLandingTodayUpSection>
) {
  return useInfiniteQuery(
    landingFactory.infiniteStaticLandingTodayUpSection(...args)
  );
}

useInfiniteStaticLandingTodayUpSectionQuery.getKey = (
  ...args: Parameters<
    typeof LANDING_QUERY_KEY_MAP.infiniteStaticLandingTodayUpSection
  >
) => [...LANDING_QUERY_KEY_MAP.infiniteStaticLandingTodayUpSection(...args)];
